import React from 'react';
import { Field } from 'formik';
import get from 'lodash/get';
import { TimePicker } from '@lavu-pos/stellar';
import PropTypes from 'prop-types';

const FormikTimePicker = ({ name, onChange, ...otherProps }) => (
	<Field
		name={name}
		render={({ form: { errors, touched, setFieldValue, setValues } }) => (
			<TimePicker
				{...otherProps}
				name={name}
				error={Boolean(get(touched, name) && get(errors, name))}
				onChange={args => onChange(args, setFieldValue, setValues)}
			/>
		)}
	/>
);

FormikTimePicker.propTypes = {
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func,
};

export default FormikTimePicker;
